export class BaseModel {
  isActive = true;
  createdBy: number;
  updatedBy: number;
  createdDate: Date;
  updatedDate: Date;
}
